import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFab,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonModal,
  IonRow,
  IonSpinner,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {
  checkboxOutline,
  checkmarkDoneCircleOutline,
  chevronBack,
  pencilOutline,
  shieldHalfOutline,
  warningOutline,
} from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSignStatus } from "../../../store/documentSignerShow";
import { signDocument } from "../../../store/documentSignerShow/actions/signDocument";
import { selectCanSign } from "../../../store/documentSignerShow/selectors/selectCanSign";
import { selectSignStatus } from "../../../store/documentSignerShow/selectors/selectSignStatus";

export const DocumentSignButton: React.FC = () => {
  const dispatch = useDispatch();
  const canSign = useSelector(selectCanSign);
  const signStatus = useSelector(selectSignStatus);
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {canSign && (
        <IonFab vertical="bottom" horizontal="end" slot="fixed">
          <IonButton onClick={() => setShowModal(true)} color="secondary" size="large" disabled={signStatus === "pending"}>
            <IonIcon icon={pencilOutline}></IonIcon>
            <IonText class="ion-padding-start">Firmar acuerdo</IonText>
          </IonButton>
        </IonFab>
      )}

      <IonModal
        isOpen={showModal}
        onDidDismiss={() => {
          setShowModal(false);
          dispatch(setSignStatus());
        }}
      >
        <IonHeader translucent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => setShowModal(false)}>
                <IonIcon icon={chevronBack} />
              </IonButton>
            </IonButtons>
            <IonTitle>Firmar acuerdo</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <br />
          <br />
          <IonGrid style={{ height: "100%", width: "100%" }} class="ion-padding">
            <IonRow class="ion-align-items-baseline" style={{ height: "100%" }}>
              <IonCol size="12" class="ion-padding-top">
                {signStatus === "pending" && (
                  <>
                    <IonSpinner name="lines" />
                    <h2>Se está firmando el acuerdo</h2>
                  </>
                )}

                {signStatus === "fulfilled" && (
                  <>
                    <IonIcon
                      icon={checkmarkDoneCircleOutline}
                      size="large"
                      color="success"
                    ></IonIcon>
                    <h2>Acuerdo firmado correctamente</h2>
                  </>
                )}

                {signStatus === "rejected" && (
                  <>
                    <IonIcon icon={warningOutline} size="large" color="error"></IonIcon>
                    <h2>Ha ocurrido un problema con la firma del acuerdo</h2>
                  </>
                )}

                {!signStatus && (
                  <>
                    <IonIcon icon={shieldHalfOutline} size="large" color="primary"></IonIcon>
                    <h2>Firmar acuerdo digitalmente</h2>
                    <p>
                      <IonIcon icon={checkboxOutline}></IonIcon>
                      <IonText class="ion-padding-start">
                        Al firmar el acuerdo estoy aceptando la veracidad de su contenido
                      </IonText>
                    </p>
                  </>
                )}
                {signStatus !== "fulfilled" && (
                <IonButton
                  onClick={() => dispatch(signDocument())}
                  disabled={signStatus === "pending"}
                  color="secondary"
                >
                  <IonIcon icon={pencilOutline}></IonIcon>
                  <IonText class="ion-padding-start">Firmar acuerdo</IonText>
                </IonButton>
              )}

              {signStatus === "fulfilled" && (
                <IonButton onClick={() => setShowModal(false)}>Volver</IonButton>
              )}
              </IonCol>
              {/* <span style={{ display: "flex", flex: 1 }}></span> */}
              
            </IonRow>
          </IonGrid>
        </IonContent>

        <IonFooter style={{ display: "flex" }}>

        </IonFooter>
      </IonModal>
    </>
  );
};
